// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/Site/Contactos/Contactos.module.css */

main {
    margin-top: 80px;
    padding: 40px 20px;
    background-color: #ffffff;
}

.Contactos_contactoConnosco__ws6bk {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 30px;
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
}

.Contactos_ladoEsquerdo__UdRWU,
.Contactos_ladoDireito__yCcfy {
    flex: 1 1 45%;
    /* A largura inicial é 45%, mas vamos ajustar isso no media query */
    padding: 20px;
    box-sizing: border-box;
}

/* Ajustes para os textos */
.Contactos_textoContactos__a5xql h3 {
    font-family: "Space Grotesk", sans-serif;
    font-optical-sizing: auto;
    font-weight: 700;
    font-style: normal;
    font-size: 3.4rem;
    color: #007bff;
    margin-bottom: 20px;
}

.Contactos_textoContactos__a5xql p {
    font-size: 16px;
    color: #333;
    margin-bottom: 10px;
    line-height: 1.6;
}

.Contactos_textoContactos__a5xql h2 {
    font-size: 20px;
    color: #555;
    margin: 20px 0 10px;
}

/* Ajustes no Mapa */
.Contactos_MapaLiftad__7w2Dr {
    margin: 30px 0;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.342);
}

/* Ajustes nos botões de localização */
.Contactos_locationButtons__rP3O7 {
    display: flex;
    justify-content: space-around;
    margin-top: 20px;
    margin-bottom: 20px;
}

.Contactos_locationButtonInfantado__eSPQS,
.Contactos_locationButtonFanhoes__WznKo,
.Contactos_locationButtonTojal__s2wBy {
    background-color: #1e1e1e;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    transition: background-color 0.3s ease;
    width: 120px;
}

.Contactos_locationButtonInfantado__eSPQS:hover,
.Contactos_locationButtonFanhoes__WznKo:hover,
.Contactos_locationButtonTojal__s2wBy:hover {
    background-color: #474747;
}

.Contactos_locationButtonInfantado__eSPQS:active {
    background-color: var(--color-i-logo);
}

.Contactos_locationButtonFanhoes__WznKo:active {
    background-color: var(--color-f-logo);
}

.Contactos_locationButtonTojal__s2wBy:active {
    background-color: var(--color-t-logo);
}

.Contactos_locationButtonInfantado__eSPQS:focus {
    outline: none;
    box-shadow: 0 0 0 3px var(--color-i-logo);
}

.Contactos_locationButtonFanhoes__WznKo:focus {
    outline: none;
    box-shadow: 0 0 0 3px var(--color-f-logo);
}

.Contactos_locationButtonTojal__s2wBy:focus {
    outline: none;
    box-shadow: 0 0 0 3px var(--color-t-logo);
}

/* Ajustes nos ícones de redes sociais */
.Contactos_logosContactos__krfem {
    display: flex;
    gap: 20px;
    margin-top: 20px;
}

.Contactos_logosContactos__krfem a {
    font-size: 24px;
    color: #1e1e1e;
    transition: color 0.3s;
}

.Contactos_instagramContactos__-IJqo:hover {
    color: #e4405f;
}

.Contactos_facebookContactos__CK0B-:hover {
    color: #3b5998;
}

.Contactos_youtubeContactos__uAMeu:hover {
    color: #ff0000;
}

.Contactos_ladoDireito__yCcfy h3 {
    font-family: "Space Grotesk", sans-serif;
    font-optical-sizing: auto;
    font-weight: 700;
    font-style: normal;
    font-size: 2.4rem;
    color: #1e1e1e;
    margin-bottom: 20px;
    margin-top: 70px;
}

/* Media Query para Tamanhos de Tela Menores */
@media (max-width: 768px) {
    .Contactos_contactoConnosco__ws6bk {
        flex-direction: column;
        padding: 10px;
        /* Reduzimos o padding para dispositivos pequenos */
    }

    .Contactos_ladoEsquerdo__UdRWU,
    .Contactos_ladoDireito__yCcfy {
        flex: 1 1 100%;
        /* Ambos os lados ocupam 100% da largura */
        padding: 10px;
    }

    .Contactos_textoContactos__a5xql h3 {
        font-size: 24px;
    }
    .Contactos_ladoDireito__yCcfy h3 {
        font-size: 24px;
    }

    .Contactos_textoContactos__a5xql p {
        font-size: 14px;
    }

    .Contactos_locationButtons__rP3O7 {
        flex-direction: column;
        /* Botões de localização empilhados para telas menores */
        align-items: center;
        /* Alinhando os botões no centro */
    }

    .Contactos_locationButtonInfantado__eSPQS,
    .Contactos_locationButtonFanhoes__WznKo,
    .Contactos_locationButtonTojal__s2wBy {
        width: 100%;
        /* Botões ocupam 100% da largura disponível */
        max-width: 200px;
        /* Limite máximo de largura para os botões */
        margin-bottom: 10px;
        /* Espaço entre os botões */
    }

    .Contactos_logosContactos__krfem {
        justify-content: center;
        /* Redes sociais empilhadas em vez de alinhadas horizontalmente */
        gap: 15px;
        align-items: center;
        /* Alinhando as redes sociais no centro */
    }

    .Contactos_logosContactos__krfem a {
        font-size: 20px;
        /* Reduzindo o tamanho dos ícones para telas pequenas */
    }

    /* Ajustes no mapa para responsividade */
    .Contactos_MapaLiftad__7w2Dr iframe {
        width: 100%;
        /* Garantir que o mapa ocupe 100% da largura */
        height: 250px;
        /* Ajustar a altura do mapa */
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Site/Contactos/Contactos.module.css"],"names":[],"mappings":"AAAA,kDAAkD;;AAElD;IACI,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,aAAa;AACjB;;AAEA;;IAEI,aAAa;IACb,mEAAmE;IACnE,aAAa;IACb,sBAAsB;AAC1B;;AAEA,2BAA2B;AAC3B;IACI,wCAAwC;IACxC,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA,sCAAsC;AACtC;IACI,aAAa;IACb,6BAA6B;IAC7B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;;IAGI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;IACtC,YAAY;AAChB;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,yCAAyC;AAC7C;;AAEA,wCAAwC;AACxC;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,8CAA8C;AAC9C;IACI;QACI,sBAAsB;QACtB,aAAa;QACb,mDAAmD;IACvD;;IAEA;;QAEI,cAAc;QACd,0CAA0C;QAC1C,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,wDAAwD;QACxD,mBAAmB;QACnB,kCAAkC;IACtC;;IAEA;;;QAGI,WAAW;QACX,6CAA6C;QAC7C,gBAAgB;QAChB,4CAA4C;QAC5C,mBAAmB;QACnB,2BAA2B;IAC/B;;IAEA;QACI,uBAAuB;QACvB,iEAAiE;QACjE,SAAS;QACT,mBAAmB;QACnB,yCAAyC;IAC7C;;IAEA;QACI,eAAe;QACf,uDAAuD;IAC3D;;IAEA,wCAAwC;IACxC;QACI,WAAW;QACX,8CAA8C;QAC9C,aAAa;QACb,6BAA6B;IACjC;AACJ","sourcesContent":["/* src/pages/Site/Contactos/Contactos.module.css */\r\n\r\nmain {\r\n    margin-top: 80px;\r\n    padding: 40px 20px;\r\n    background-color: #ffffff;\r\n}\r\n\r\n.contactoConnosco {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: space-between;\r\n    gap: 30px;\r\n    max-width: 1200px;\r\n    margin: 0 auto;\r\n    padding: 20px;\r\n}\r\n\r\n.ladoEsquerdo,\r\n.ladoDireito {\r\n    flex: 1 1 45%;\r\n    /* A largura inicial é 45%, mas vamos ajustar isso no media query */\r\n    padding: 20px;\r\n    box-sizing: border-box;\r\n}\r\n\r\n/* Ajustes para os textos */\r\n.textoContactos h3 {\r\n    font-family: \"Space Grotesk\", sans-serif;\r\n    font-optical-sizing: auto;\r\n    font-weight: 700;\r\n    font-style: normal;\r\n    font-size: 3.4rem;\r\n    color: #007bff;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.textoContactos p {\r\n    font-size: 16px;\r\n    color: #333;\r\n    margin-bottom: 10px;\r\n    line-height: 1.6;\r\n}\r\n\r\n.textoContactos h2 {\r\n    font-size: 20px;\r\n    color: #555;\r\n    margin: 20px 0 10px;\r\n}\r\n\r\n/* Ajustes no Mapa */\r\n.MapaLiftad {\r\n    margin: 30px 0;\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.342);\r\n}\r\n\r\n/* Ajustes nos botões de localização */\r\n.locationButtons {\r\n    display: flex;\r\n    justify-content: space-around;\r\n    margin-top: 20px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.locationButtonInfantado,\r\n.locationButtonFanhoes,\r\n.locationButtonTojal {\r\n    background-color: #1e1e1e;\r\n    color: white;\r\n    border: none;\r\n    padding: 10px 20px;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    font-size: 16px;\r\n    transition: background-color 0.3s ease;\r\n    width: 120px;\r\n}\r\n\r\n.locationButtonInfantado:hover,\r\n.locationButtonFanhoes:hover,\r\n.locationButtonTojal:hover {\r\n    background-color: #474747;\r\n}\r\n\r\n.locationButtonInfantado:active {\r\n    background-color: var(--color-i-logo);\r\n}\r\n\r\n.locationButtonFanhoes:active {\r\n    background-color: var(--color-f-logo);\r\n}\r\n\r\n.locationButtonTojal:active {\r\n    background-color: var(--color-t-logo);\r\n}\r\n\r\n.locationButtonInfantado:focus {\r\n    outline: none;\r\n    box-shadow: 0 0 0 3px var(--color-i-logo);\r\n}\r\n\r\n.locationButtonFanhoes:focus {\r\n    outline: none;\r\n    box-shadow: 0 0 0 3px var(--color-f-logo);\r\n}\r\n\r\n.locationButtonTojal:focus {\r\n    outline: none;\r\n    box-shadow: 0 0 0 3px var(--color-t-logo);\r\n}\r\n\r\n/* Ajustes nos ícones de redes sociais */\r\n.logosContactos {\r\n    display: flex;\r\n    gap: 20px;\r\n    margin-top: 20px;\r\n}\r\n\r\n.logosContactos a {\r\n    font-size: 24px;\r\n    color: #1e1e1e;\r\n    transition: color 0.3s;\r\n}\r\n\r\n.instagramContactos:hover {\r\n    color: #e4405f;\r\n}\r\n\r\n.facebookContactos:hover {\r\n    color: #3b5998;\r\n}\r\n\r\n.youtubeContactos:hover {\r\n    color: #ff0000;\r\n}\r\n\r\n.ladoDireito h3 {\r\n    font-family: \"Space Grotesk\", sans-serif;\r\n    font-optical-sizing: auto;\r\n    font-weight: 700;\r\n    font-style: normal;\r\n    font-size: 2.4rem;\r\n    color: #1e1e1e;\r\n    margin-bottom: 20px;\r\n    margin-top: 70px;\r\n}\r\n\r\n/* Media Query para Tamanhos de Tela Menores */\r\n@media (max-width: 768px) {\r\n    .contactoConnosco {\r\n        flex-direction: column;\r\n        padding: 10px;\r\n        /* Reduzimos o padding para dispositivos pequenos */\r\n    }\r\n\r\n    .ladoEsquerdo,\r\n    .ladoDireito {\r\n        flex: 1 1 100%;\r\n        /* Ambos os lados ocupam 100% da largura */\r\n        padding: 10px;\r\n    }\r\n\r\n    .textoContactos h3 {\r\n        font-size: 24px;\r\n    }\r\n    .ladoDireito h3 {\r\n        font-size: 24px;\r\n    }\r\n\r\n    .textoContactos p {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .locationButtons {\r\n        flex-direction: column;\r\n        /* Botões de localização empilhados para telas menores */\r\n        align-items: center;\r\n        /* Alinhando os botões no centro */\r\n    }\r\n\r\n    .locationButtonInfantado,\r\n    .locationButtonFanhoes,\r\n    .locationButtonTojal {\r\n        width: 100%;\r\n        /* Botões ocupam 100% da largura disponível */\r\n        max-width: 200px;\r\n        /* Limite máximo de largura para os botões */\r\n        margin-bottom: 10px;\r\n        /* Espaço entre os botões */\r\n    }\r\n\r\n    .logosContactos {\r\n        justify-content: center;\r\n        /* Redes sociais empilhadas em vez de alinhadas horizontalmente */\r\n        gap: 15px;\r\n        align-items: center;\r\n        /* Alinhando as redes sociais no centro */\r\n    }\r\n\r\n    .logosContactos a {\r\n        font-size: 20px;\r\n        /* Reduzindo o tamanho dos ícones para telas pequenas */\r\n    }\r\n\r\n    /* Ajustes no mapa para responsividade */\r\n    .MapaLiftad iframe {\r\n        width: 100%;\r\n        /* Garantir que o mapa ocupe 100% da largura */\r\n        height: 250px;\r\n        /* Ajustar a altura do mapa */\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contactoConnosco": `Contactos_contactoConnosco__ws6bk`,
	"ladoEsquerdo": `Contactos_ladoEsquerdo__UdRWU`,
	"ladoDireito": `Contactos_ladoDireito__yCcfy`,
	"textoContactos": `Contactos_textoContactos__a5xql`,
	"MapaLiftad": `Contactos_MapaLiftad__7w2Dr`,
	"locationButtons": `Contactos_locationButtons__rP3O7`,
	"locationButtonInfantado": `Contactos_locationButtonInfantado__eSPQS`,
	"locationButtonFanhoes": `Contactos_locationButtonFanhoes__WznKo`,
	"locationButtonTojal": `Contactos_locationButtonTojal__s2wBy`,
	"logosContactos": `Contactos_logosContactos__krfem`,
	"instagramContactos": `Contactos_instagramContactos__-IJqo`,
	"facebookContactos": `Contactos_facebookContactos__CK0B-`,
	"youtubeContactos": `Contactos_youtubeContactos__uAMeu`
};
export default ___CSS_LOADER_EXPORT___;
